<div class="d-flex-center justify-space-between p-t-30 p-b-5">
    <button
        (click)="markQuestionAsComplete()"
        [disabled]="isSaveButtonDisabled()"
        class="d-flex-center fs-14 height-32"
        color="primary"
        i18n
        id="question-submit-button"
        mat-stroked-button
        type="submit"
    >
        <mat-icon class="fs-18 m-t-2">done</mat-icon>
        OK
    </button>
    @if (commonQuestionnaireService.reviewMode) {
    <button
        mat-stroked-button
        id="question-cancel-button fs-14 height-32"
        color="warn"
        type="submit"
        i18n
        class="m-l-auto d-flex-center"
        [disabled]="!questionReview || (questionReview && questionReview.solved) || reviewInitialValue"
        (click)="cancelReviewButton()"
    >
        Cancel review
    </button>
    }
    <div class="d-flex">
        <input
            #uploadInputElement
            (change)="onAttachmentUpload($event)"
            [accept]="extensionsAllowed.join(',')"
            hidden
            type="file"
        />
        @if (question && currentAttachment && !currentAttachment.file && question.allow_attachment) {
        <mat-icon
            (click)="uploadInputElement.click()"
            class="attachment-icon fs-20"
            >attach_file
        </mat-icon>
        } @if (currentAttachment && currentAttachment.file) {
        <mat-chip-listbox
            class="mat-chip-list-stacked"
            aria-orientation="vertical"
        >
            <mat-chip
                class="auto-width"
                disableRipple
            >
                {{ currentAttachment.file.name }}
                <mat-icon
                    matChipRemove
                    style="color: black; opacity: 0.8"
                    (click)="removeAttachment()"
                >
                    cancel
                </mat-icon>
            </mat-chip>
        </mat-chip-listbox>
        }
    </div>
</div>
